@if (companyContactInfo) {
  <p-table
    [columns]="companyContactInfoColumns"
    [value]="companyContactInfo.adminContacts ?? []">
    <ng-template #colgroup let-columns>
      <colgroup>
      @for (col of columns; track col) {
        <col [style.width]="col.width"/>
      }
    </colgroup>
  </ng-template>
  <ng-template #header let-columns>
    <tr>
      @for (col of columns; track col) {
        <th [pSortableColumn]="col.field">
          {{col.header}}
        </th>
      }
    </tr>
  </ng-template>
  <ng-template #body let-contact>
    <tr>
      <td class="contact-cell">{{contact.name}}</td>
      <td class="contact-cell">{{contact.email}}</td>
      <td class="contact-cell">{{contact.phone}}</td>
    </tr>
  </ng-template>
</p-table>
}
@if (!companyContactInfo) {
  <p>
    Company Contact Information cannot be found.
  </p>
}
